import { AuditDetails, CreativeMarket, Moderation } from 'components/common/types/Creative.types';

const descSorted = (combineAuditDetails: AuditDetails[] = []): AuditDetails[] =>
  combineAuditDetails.sort(
    (a: AuditDetails, b: AuditDetails) =>
      new Date(b.updateStamp || b.createdAt).getTime() - new Date(a.updateStamp || a.createdAt).getTime(),
  );

export const combineAuditDetails = (
  moderation: Moderation[] = [],
  auditLogs: { id: string; createdAt: number }[] = [],
): AuditDetails[] => descSorted([...moderation, ...auditLogs] as AuditDetails[]);

export const combineAuditDetailsReseller = (
  currentMarket: CreativeMarket,
  creativeDetails: { market: CreativeMarket[] },
  environmentId: string,
): AuditDetails[] => {
  const otherMarkets = creativeDetails?.market?.filter(({ environment }) => environment !== environmentId);

  const otherModeration = otherMarkets.flatMap((market) =>
    market.moderation?.map((mod) => ({ ...mod, publisher: market.publisher })),
  );
  const otherAuditLogs = otherMarkets.flatMap((market) =>
    market.auditLogs?.map((log) => ({ ...log, publisher: market.publisher })),
  );

  return combineAuditDetails(
    [...otherModeration, ...(currentMarket?.moderation ?? [])],
    [...otherAuditLogs, ...(currentMarket?.auditLogs ?? [])],
  );
};
